import { render } from "./clientprofiletab.vue?vue&type=template&id=4c923373"
import script from "./clientprofiletab.vue?vue&type=script&lang=js"
export * from "./clientprofiletab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__